import { createFileRoute } from '@tanstack/react-router'
import UserGeneral from 'User/components/Sections/UserGeneral'

export const Route = createFileRoute('/user/$userId/general')({
    component: UserGeneral,
})
